module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"classes_guides_play_level","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"courseID":{"type":"string"},"language":{"type":"string","description":"Programming language."},"levelSlug":{"type":"string","maxLength":128}},"required":["user","courseID","language","levelSlug"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/classes_guides_play_level.json
// module id = 526
// module chunks = 100